import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import StbButton from "../../atoms/button/StbButton";
import "./CreateProjectBriljantIntegration.css";
import { useQueryClient } from "@tanstack/react-query";
import { ICreateProjectIntegrationProps } from "./CreateProjectBriljantIntegration.types";
import DropDownSelectProject from "../../molecules/dropdown-select-project/DropDownSelectProject";
import LoadingSection from "../../atoms/loadingsection/LoadingSection";
import { useNavigate } from "react-router-dom";
import { useGetApiErpImportGetAllProjects } from "../../../api/generated/endpoints/erp-import/erp-import";

const ERP_LIST_STALE_TIME_MS = 5 * 60 * 1000;

const CreateProjectByggkollenIntegration: React.FC<
  ICreateProjectIntegrationProps
> = (props) => {
  const {
    setDepartment: onDepartmentChange,
    setErpReference: onErpReferenceChange,
  } = props;
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const [selectedErpReference, setSelectedErpReference] = useState<
    string | undefined
  >();
  const [department, setDepartment] = useState<number | undefined>();

  const { data: projects, isLoading: isProjectsLoading } = useGetApiErpImportGetAllProjects(
    {
      query: {
        staleTime: ERP_LIST_STALE_TIME_MS,
      },
    }
  );

  return (
    <Container>
      <Row className="w-full d-flex justify-content-center mt-3">
        <Col xs={11} sm={12} md={10} l={9} xl={8} xxl={6}>
          <DropDownSelectProject
            projects={projects}
            setSelectedProjectNumber={() => { return; }}
            setErpReference={setSelectedErpReference}
            setDepartment={setDepartment}
          />
        </Col>
      </Row>
      <Row className="d-flex justify-content-center mt-3">
        <Col xs="auto">
          <StbButton
            variant="primary"
            disabled={!selectedErpReference}
            type="submit"
            onClick={(e) => {
            e.preventDefault();
            queryClient.invalidateQueries({ queryKey: ["project"] });
            onErpReferenceChange(selectedErpReference);
            onDepartmentChange(department);

            const selectedProject = projects?.find(
              (p) => String(p.erpReference ?? "") === selectedErpReference
            );
            const erpReferenceValue =
              selectedProject?.erpReference ?? selectedErpReference;

            if (erpReferenceValue) {
              const urlParams = new URLSearchParams();
              urlParams.set("erpReference", erpReferenceValue);
              navigate(`/createproject?${urlParams.toString()}`);
            }
            }}
          >
            Hämta
          </StbButton>
        </Col>
      </Row>
      {isProjectsLoading && <LoadingSection text="Laddar.." />}
    </Container>
  );
};

export default CreateProjectByggkollenIntegration;
